export default __webpack_public_path__ + "a075ee4d723d78c3109fb409cb2451c6.png";